import get from 'lodash/get';

import createReducer from '../utils/createReducer';
import { API_CALL_REQUEST, API_CALL_SUCCESS } from '../constants/actionTypes';
import decodePagination from '../normalizers/decodePagination';
import { PRIZES } from '../constants/apiTypes';

const initialState = {
  currentPage: 1,
  hasNextPage: false,
  isLoading: true,
  items: []
};

const prizesReducer = createReducer(initialState, {
  [API_CALL_REQUEST]: (state, action) => {
    if (action.api === PRIZES) {
      return {
        isLoading: true
      };
    }
    return undefined;
  },

  [API_CALL_SUCCESS]: (state, action) => {
    if (action.api !== PRIZES) {
      return undefined;
    }

    const pagination = decodePagination(get(action.meta, 'pagination'));
    return {
      ...state,
      currentPage: pagination.currentPage,
      hasNextPage: pagination.hasNextPage,
      isLoading: false,
      items: action.data || []
    };
  }
});

export default prizesReducer;
